var map = {
	"./BBQRestaurentSite.jpg": 29,
	"./EcommerceSite.jpg": 30,
	"./NetflixClone.jpg": 31,
	"./NirvanaRestaurant.png": 32,
	"./PackageTrackerSite.jpg": 33,
	"./SimbaApp.png": 34,
	"./ToDoListSite.jpg": 35,
	"./c-sharp.png": 36,
	"./contact-bg.jpg": 37,
	"./css.png": 38,
	"./facebook.png": 14,
	"./fire.png": 39,
	"./firebase.png": 40,
	"./get-resume.png": 41,
	"./git-logo.png": 42,
	"./hero-bg-1.JPG": 43,
	"./hero-bg-2.png": 44,
	"./hero-bg-5.jpg": 45,
	"./hero-bg.jpg": 46,
	"./html.png": 47,
	"./java.png": 48,
	"./js.png": 49,
	"./linkedin.png": 15,
	"./net.png": 50,
	"./package-tracker-screenshot.png": 51,
	"./portfolio-logo.png": 7,
	"./react.png": 52,
	"./snehal-pic-2.png": 53,
	"./snehal-pic-3.png": 54,
	"./snehal-pic.png": 16,
	"./sql.png": 55,
	"./twitter.png": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;